import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import whiteLogoSrc from 'assets/full_leal_logo_white.svg';
import darkLogoSrc from 'assets/full_leal_logo_dark.svg';
import noTitleLogoSrc from 'assets/logo_no_title.svg';
import { LoginButton } from 'components/LoginButton/LoginButton';
import LanguageMenu from 'new-ui/Components/LanguageMenu';
import { HEADER_THEME } from '../constants';
import styles from './defaultPageHeaderView.module.css';

export const DefaultPageHeaderView = ({
  backgroundColor,
  isProviderMode,
  isLogoShown = true,
  onLogoClick,
  theme = HEADER_THEME.DEFAULT,
  isLanguageMenuShown,
  isLoginButtonShown,
  headerRightSlot,
}) => (
  <header
    className={cx(
      styles.root,
      isProviderMode ? styles.providerRoot : styles.nonProviderRoot,
      { [HEADER_THEME.DEFAULT]: styles.defaultRoot, [HEADER_THEME.WHITE]: styles.whiteRoot }[theme],
    )}
    style={{ backgroundColor }}
  >
    {isLogoShown && (
      <>
        <img
          className={styles.logo}
          src={theme === HEADER_THEME.WHITE ? darkLogoSrc : whiteLogoSrc}
          alt="Leal Health Logo"
          onClick={onLogoClick}
        />
        <img
          className={styles.logoNoTitle}
          src={noTitleLogoSrc}
          alt="Leal Health Logo"
          onClick={onLogoClick}
        />
      </>
    )}
    {headerRightSlot && (
      <div className={styles.rightSlot}>
        {headerRightSlot}
      </div>
    )}
    {(isLanguageMenuShown || isLoginButtonShown) && (
      <div className={styles.rightCornerSlot}>
        {isLanguageMenuShown && <LanguageMenu />}
        {isLoginButtonShown && <LoginButton color={theme === HEADER_THEME.DEFAULT ? 'primary' : undefined} />}
      </div>
    )}
  </header>
);

DefaultPageHeaderView.propTypes = {
  isProviderMode: PropTypes.bool.isRequired,
  isLogoShown: PropTypes.bool,
  isLoginButtonShown: PropTypes.bool,
  isLanguageMenuShown: PropTypes.bool,
  onLogoClick: PropTypes.func,
  headerRightSlot: PropTypes.node,
  backgroundColor: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(HEADER_THEME)),
};
